// @flow

import Telemetry, { Observers } from '@atlassian/mpac-telemetry';
import { getCLS, getFCP, getFID, getLCP, getTTFB } from 'web-vitals';

const { getNetworkRequestTimes, waitForTimeToInteractive, PageVisibilityObserver } = Observers;

const amktContainer = document.getElementById('amkt-frontend-content');

if (!amktContainer) {
  console.error('Did not find the root container, complete telemetry will not be sent');
}

// Start listening for page visibility change so we can
// differentiate foreground events from background events later
PageVisibilityObserver.start();

getFCP(({ value }) => Telemetry.timeToFirstPaint(value));
getLCP(({ value }) => Telemetry.timeToLargestContentfulPaint(value));
getTTFB(({ value }) => Telemetry.timeToFirstByte(value));
getFID(({ value }) => Telemetry.firstInputDelay(value));

// Measured only when page is hidden / unloaded
getCLS(({ value }) => Telemetry.cumulativeLayoutShift(value));

if (
  'Promise' in window &&
  'PerformanceObserver' in window &&
  'PerformanceLongTaskTiming' in window &&
  'PerformancePaintTiming' in window &&
  amktContainer
) {
  waitForTimeToInteractive(amktContainer)
    .then(tti => {
      Telemetry.timeToInteractive(tti);

      const requestTransferTimes = getNetworkRequestTimes(
        [
          /marketplace.*atlassian.com/,
          /marketplace-cdn.atlassian.com/,
          /:\/\/localhost/,
          /algolianet.com/,
        ],
        []
      );

      requestTransferTimes.forEach(requestGroup =>
        Telemetry.resourceDownloadTime(requestGroup.type, requestGroup.duration)
      );
    })
    .catch(console.error.bind(console));
}
